import React from 'react';
import { withTranslation } from 'react-i18next';
import { Alert, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, InputGroup, InputGroupAddon, Input } from "reactstrap";
import Button from './button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cardBrands } from './../global-props';
import { SettingsContext } from "./context";
import {
    initMercadoPago,
    createCardToken,
    CardNumber,
    SecurityCode,
    ExpirationDate,
    getIdentificationTypes,
  } from '@mercadopago/sdk-react';
class MercadoCardForm extends React.Component {
  static contextType = SettingsContext;

  constructor(props) {
    super(props);
    this.state = {
      cardholderName: "",
      cardholderEmail: "",
      identificationTypes: [],
      identificationType: "",
      identificationNumber: "",
      isSubmitting: false,
      canContinue: false,
      error: null,
      confirmed: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount(){
    if (window.addEventListener) { window.addEventListener("message", this.ReadPostMessage, false); } else { window.attachEvent("onmessage", this.ReadPostMessage); }
    let {settings} = this.props.settings ? this.props : this.context;
    initMercadoPago(settings.stripePK.value);
    this.getIdTypes();
    if(this.props.paymentType==="saved" && this.props.savedCards.length===1){
      this.setState({selectedCardId: this.props.savedCards[0].id, selectedCard: this.props.savedCards[0], canContinue: true})
    }
  }

  async getIdTypes() {
    const identificationTypes = await getIdentificationTypes();
    this.setState({identificationTypes});
  }

  async handleSubmit(ev){
    const { cardholderName, cardholderEmail, identificationType, identificationNumber, selectedCard, selectedCardId} = this.state;
    ev.preventDefault();
    this.props.handleIsLoading(true);
    if(this.props.paymentType!=="saved"){
      if(cardholderName && cardholderEmail && identificationType && identificationNumber){
        try {
          this.setState({error: null})
          const response = await createCardToken({
            cardholderName,
            cardholderEmail,
            identificationType,
            identificationNumber,
          })
          this.props.onSubmit(response, cardholderEmail);
          console.log('Card Token Response = ', response)
        } catch(error){
          this.props.handleIsLoading(false);
          this.setState({error});
          console.log(error);
        }
      } else {
        this.setState({error: [{message: "Make sure all fields are filled out."}]})
      }
    } else {
      try {
        this.setState({error: null})
        const response = await createCardToken({
          cardId: selectedCardId
        })
        response.last4 = selectedCard.last4;
        this.props.onSubmit(response, cardholderEmail);
        console.log('Card Token Response = ', response)
      } catch(error){
        this.props.handleIsLoading(false);
        this.setState({error});
        console.log(error);
      }
    }
  }

  handleChange(e, name) {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    this.setState({[name]: value});
  }

  render() {
    const { t, isLoading, paymentType, savedCards } = this.props;
    const { canContinue, selectedCardId, cardholderName, cardholderEmail, identificationNumber, identificationTypes, identificationType } = this.state;
    return <div>
    {this.state.error && this.state.error.length?
      <Alert color="danger">
        {this.state.error.map(err => <div>{t(err.message)}</div>)}
      </Alert>
    :null}
    {paymentType!=="saved"?
    <form id="mercadoForm" autoComplete="off">
      <div className="dir-ltr">
        <CardNumber placeholder='Card Number'/>
        <SecurityCode placeholder='Security Code' />
        <ExpirationDate placeholder='Expiration Date' mode='short'/>
        <div className="form-group">
          <input type="text" id="cardHolderName" className="font-weight-normal form-control chid dir-ltr" onChange={(e) => this.handleChange(e, "cardholderName")} value={cardholderName} name="cardholderName" placeholder="Cardholder Name"/>
        </div>
        <div className="form-group">
          <input type="email" id="cardHolderEmail" className="font-weight-normal form-control chid dir-ltr" onChange={(e) => this.handleChange(e, "cardholderEmail")} value={cardholderEmail} name="cardholderEmail" placeholder="Cardholder Email"/>
        </div>
        <div className="idGroup">
          <UncontrolledDropdown>
            <DropdownToggle className="identificationType" caret>{identificationType?identificationType:t("Select ID Type")}</DropdownToggle>
              <DropdownMenu>
                {identificationTypes.map((val, i) =>{
                  return <DropdownItem className={val.name==identificationType?'active':''} key={i} onClick={()=>this.setState({identificationType: val.name})}>{val.name}</DropdownItem>
                }
                )}
              </DropdownMenu>
          </UncontrolledDropdown>
          <div className="form-group id-group">
            <input type="number" id="identificationNumber" className="font-weight-normal form-control chid dir-ltr" onChange={(e) => this.handleChange(e, "identificationNumber")} value={identificationNumber} name="identificationNumber" placeholder="Identification Number"/>
          </div>
        </div>
        <Button type="secondary mx-auto btn-lg" className="mb-2" disabled={this.props.disabled} loading={isLoading} onClick={(e) => this.handleSubmit(e)}>{this.props.paymentButtonText?t(this.props.paymentButtonText):t('Charge Card')}</Button>
      </div>
    </form>
    :
      <form id="mercadoForm" autoComplete="off">
        <div className="payment-methods">
            {savedCards.map((card,i) =>
              <li className={selectedCardId===card.id?'active':''} key={i} onClick={() => this.setState({selectedCardId: card.id, selectedCard: card, canContinue: true})}>
                <div className="icon-check"><FontAwesomeIcon icon="check" /></div>
                <div>{card.brand} •••• {typeof card.last4 === 'string' && card.last4.slice(- 4)}</div>
                <div className="icon-brand"><FontAwesomeIcon icon={cardBrands[card.brand]?cardBrands[card.brand].icon:'Unknown'} /></div>
              </li>
            )}
            <SecurityCode placeholder='Security Code' />
            <Button type="secondary mx-auto btn-lg" className="mb-2" disabled={this.props.disabled||!canContinue} loading={isLoading} onClick={(e) => this.handleSubmit(e)}>{this.props.paymentButtonText?t(this.props.paymentButtonText):t('Charge Card')}</Button>
        </div>
      </form>
    }
    </div>
  }
}
export default withTranslation()(MercadoCardForm);